import { column } from '../db/schema/Column.js';
import { Table } from '../db/schema/Table.js';
/**
 * The default name of the local table storing attachment data.
 *
 * @alpha
 */
export const ATTACHMENT_TABLE = 'attachments';
/**
 * Maps a database row to an AttachmentRecord.
 *
 * @param row - The database row object
 * @returns The corresponding AttachmentRecord
 *
 * @alpha
 */
export function attachmentFromSql(row) {
    return {
        id: row.id,
        filename: row.filename,
        localUri: row.local_uri,
        size: row.size,
        mediaType: row.media_type,
        timestamp: row.timestamp,
        metaData: row.meta_data,
        hasSynced: row.has_synced === 1,
        state: row.state
    };
}
/**
 * AttachmentState represents the current synchronization state of an attachment.
 *
 * @alpha
 */
export var AttachmentState;
(function (AttachmentState) {
    AttachmentState[AttachmentState["QUEUED_UPLOAD"] = 0] = "QUEUED_UPLOAD";
    AttachmentState[AttachmentState["QUEUED_DOWNLOAD"] = 1] = "QUEUED_DOWNLOAD";
    AttachmentState[AttachmentState["QUEUED_DELETE"] = 2] = "QUEUED_DELETE";
    AttachmentState[AttachmentState["SYNCED"] = 3] = "SYNCED";
    AttachmentState[AttachmentState["ARCHIVED"] = 4] = "ARCHIVED"; // Attachment has been orphaned, i.e. the associated record has been deleted
})(AttachmentState || (AttachmentState = {}));
/**
 * @alpha
 */
export const ATTACHMENT_TABLE_COLUMNS = {
    filename: column.text,
    local_uri: column.text,
    timestamp: column.integer,
    size: column.integer,
    media_type: column.text,
    state: column.integer, // Corresponds to AttachmentState
    has_synced: column.integer,
    meta_data: column.text
};
/**
 * AttachmentTable defines the schema for the attachment queue table.
 *
 * @alpha
 */
export class AttachmentTable extends Table {
    constructor(options) {
        super(ATTACHMENT_TABLE_COLUMNS, {
            ...options,
            viewName: options?.viewName ?? ATTACHMENT_TABLE,
            localOnly: true,
            insertOnly: false
        });
    }
}
//# sourceMappingURL=Schema.js.map